import { NetworkService } from "./network-service";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

const handleKBError = (endpoint, error)=>{
    console.error(`Errore durante l'operazione su ${endpoint}: `, error);
}

export const KBService = {
    addKBFile: (formData,callback,errorCallback)=>{
        const url =`${API_BASE_URL}/api/knowledge-base/create_with_file/`;
        NetworkService.postMultiPart(url,formData,callback,(error)=>{
            handleKBError('aggiungi file kb', error);
            if (errorCallback) {
                errorCallback(error);
            }
        })
    },

    getAllKBFiles: (callback,errorCallback)=>{
        const url = `${API_BASE_URL}/api/knowledge-base/`;
        NetworkService.get(url,(data)=>{
            callback(data);
        },(error)=>{
            handleKBError('elenco dei file KB', error);
            if(errorCallback){
                errorCallback(error);
            }
        })
    },

    getKBFile: (kbFileId,callback , errorCallback)=>{
        const url = `${API_BASE_URL}/api/knowledge-base/${kbFileId}/`
        NetworkService.get(url,callback, (error)=>{
            if(errorCallback){
                errorCallback(error);
            }
        })
    },

    updateKbFile: (kbFileId, body, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/knowledge-base/${kbFileId}/`;
        NetworkService.put(url,body,callback, (error)=>{
            handleKBError(`aggiornamento del kb file con ID ${kbFileId}`,error);
            if(errorCallback){
                errorCallback(error);
            }
        })
    },

    deleteKbFile: (kbFileId, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/knowledge-base/${kbFileId}/`;
        NetworkService.delete(url,callback,(error)=>{
            handleKBError(`eliminazione del file kb con ID ${kbFileId}`,error);
            if (errorCallback) {
                errorCallback(error);
            }
        })
    },

    downloadKBFile: (kbFileId, callback, errorCallback) => {
        const url = `${API_BASE_URL}/api/knowledge-base/${kbFileId}/download/`;
        NetworkService.getBlob(url, callback, (error) => {
          if (errorCallback) {
            errorCallback(error);
          }
        });
      },

    fetchMarkdownContent: (kbFileId,token, setMarkdownContent) => {
        const url = `${API_BASE_URL}/api/knowledge-base/${kbFileId}/download/`;
    fetch(url, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Errore nel recupero del file md: ${response.status}`
          );
        }
        return response.text();
      })
      .then((text) => {
        setMarkdownContent(text);
      })
      .catch((error) => {
        console.error('Errore durante il recupero del file md:', error);
      });
  },
}